import types from "./ActionTypes";

const initialState = {
    cityList: [],
    guestTypeList: [],
    agentList: [],
    branchList: [],
    branchUserList: [],
    pickupLocation: [],
    dropoffLocation: [],
    showAlert: {
        msg: '',
        open: false,
        type: '',
        autoHideDuration: 5000,
        horizontalPosition: 'center'
    },
    bkgColor: [],
    subRoutesCity: [],
    busListAll: [],
    driverListAll: [],
    conductorListAll: [],
    pickUpManListAll: [],
    userDetails: {},
    loadingScreen: false,
    tripList: [],
    paymentMode: [],
    amenitiesList: [],
    userRole: [],
    roleRight: {},
    roleData: []
};

const Reducer = (state = initialState, action) => {
    switch (action.type) {

        case types.UPDATE_LOADING_SCREEN:
            return {
                ...state,
                loadingScreen: action.payload
            };
        case types.CITY_List:
            return {
                ...state,
                cityList: action.payload
            }
        case types.GUEST_TYPE_LIST:
            return {
                ...state,
                guestTypeList: action.payload
            }
        case types.AGENT_LIST:
            return {
                ...state,
                agentList: action.payload
            }

        case types.BRANCH_LIST:
            return {
                ...state,
                branchList: action.payload
            }
        case types.BRANCH_USER_LIST:
            return {
                ...state,
                branchUserList: action.payload
            }
        case types.PICKUP_LOCATION_LIST:
            return {
                ...state,
                pickupLocation: action.payload
            }
        case types.DROPOFF_LOCATION_LIST:
            return {
                ...state,
                dropoffLocation: action.payload
            }
        case types.SHOW_ALERT:
            return {
                ...state,
                showAlert: {
                    ...state.showAlert,
                    ...action.payload,
                }
            };
        case types.BKG_COLOR:
            return {
                ...state,
                bkgColor: action.payload
            }
        case types.SUB_ROUTES_CITY:
            return {
                ...state,
                subRoutesCity: action.payload
            }
        case types.BUSES_LIST_ALL:
            return {
                ...state,
                busListAll: action.payload
            }
        case types?.DRIVER_LIST_ALL:
            return {
                ...state,
                driverListAll: action.payload
            }
        case types?.CONDUCTOR_LIST_ALL:
            return {
                ...state,
                conductorListAll: action.payload
            }
        case types?.PICKUP_MAN_LIST_ALL:
            return {
                ...state,
                pickUpManListAll: action.payload
            }
        case types.USER_DETAILS:
            return {
                ...state,
                userDetails: action.payload,
                roleData: action.roleData,
            }
        case types.TRIP_LIST:
            return {
                ...state,
                tripList: action.payload
            }
        case types.PAYMENT_MODE:
            return {
                ...state,
                paymentMode: action.payload
            }
        case types.AMENITIES_LIST:
            return {
                ...state,
                amenitiesList: action.payload
            }

        case types.USER_ROLE:
            return {
                ...state,
                userRole: action.payload,
                roleRight: action.roleRight,
            };
        default:
            return state;
    }
}

export default Reducer;